<template>
    <button
        class="create-new-btn"
        :class="[createNewBtnClassObject, verticalAlignmentClass]"
        :disabled="isDisabled"
        @click="onClick($event)"
    >
        <icon :icon-name="icon" :disabled="isDisabled" small icon-colour-type="primary-rect" />
        <span v-if="btnText" class="create-new-btn__text font-weight-bold">
            {{ toSentenceCase($t(btnText)) }}
        </span>
    </button>
</template>

<script>
import readonly from '@/js/mixins/readonly';

export default {
    mixins: [readonly],
    props: {
        events: Object,
        preventDefault: Boolean,
        btnText: {
            required: false,
            type: String,
        },
        disabled: {
            required: false,
            type: Boolean,
            default: false,
        },
        background: {
            required: false,
            type: Boolean,
            default: false,
        },
        verticalAlignment: {
            required: false,
            type: String,
            default: 'middle',
        },
        hasBorder: {
            required: false,
            type: Boolean,
            default: false,
        },
    },
    emits: ['createNew'],
    data() {
        return {
            icon: 'custom:add',
        };
    },

    computed: {
        createNewBtnClassObject() {
            return {
                'create-new-btn--bg': this.background,
                'create-new-btn--disabled': this.disabled,
                'create-new-btn--border': this.hasBorder,
            };
        },

        verticalAlignmentClass() {
            return this.verticalAlignment
                ? `create-new-btn--${this.verticalAlignment}`
                : 'create-new-btn--middle';
        },

        isDisabled() {
            return this.disabled || this.isReadOnly;
        },
    },

    methods: {
        onClick(event) {
            if (this.events && this.events.click) this.events.click(event);
            if (!this.disabled && !this.preventDefault) this.$emit('createNew', event);
        },
    },
};
</script>

<style lang="scss" scoped>
@import '@style/base/_mixins';
@import '@style/base/_variables';

.create-new-btn {
    outline: none;

    display: inline-flex;
    flex-direction: row;
    align-items: center;

    &--disabled {
        cursor: not-allowed;
    }

    &--middle {
        vertical-align: middle;
    }

    &--top {
        vertical-align: top;
    }

    &--bottom {
        vertical-align: bottom;
    }

    &--border {
        border-radius: 0.4rem;
        background-color: $promo-primary-colour;
        padding: 0 1.2rem;
        height: 2rem;

        .create-new-btn__text {
            color: $promo-white;
            font-size: 1.2rem;
            font-weight: 400 !important;
        }
        &:hover {
            background-color: $rtls-secondary-button-hover-colour !important;
            & .v-icon rect {
                fill: $rtls-secondary-button-hover-colour !important;
            }
        }
    }

    &__text {
        color: $promo-primary-colour;
        margin-left: 0.5rem;
    }
}
</style>
